import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CloseIcon, SafeHtml, useBreakpoint, useScopedSelector } from 'ia-react-core';
import { getHostName } from 'omni-package-react-cms';
import {
  StyledT, StyledP, StyledLink, StyledTile, StyledCloseButton, StyledIconsDiv,
} from './CrossSellingContent.styles';
import { CrossSellingContent } from '../../../../interfaces/CrossSellingContent';
import { CrossSellingResourceInfo } from '../CrossSellingResource/CrossSellingResource';

export interface CrossSellingContentsProps {

}
export const SESSION_STORAGE_HIDE_CROSS_SELLING = 'we-client-space:hide-cross-selling';

const CrossSellingContents: FC<CrossSellingContentsProps> = () => {
  const ads: CrossSellingContent = useScopedSelector(CrossSellingResourceInfo.dataDst);
  const { t } = useTranslation('CrossSelling');
  const [hideCrossSelling, setHideCrossSelling] = useState<string>(sessionStorage.getItem(SESSION_STORAGE_HIDE_CROSS_SELLING));
  const hide = hideCrossSelling === 'true';
  const isXs = useBreakpoint('xs');

  if (hide || !ads) return null;
  const imgsrc = `${getHostName()}${ads?.imageSrc}`;
  return (
    <StyledTile hide={hide} isDivided={false} backgroundColor={ads?.backgroundColor}>
      <StyledCloseButton
        Icon={CloseIcon}
        iconSize={18}
        label={t('closeButton')}
        data-testid="closeCrossSelling"
        onClick={() => {
          sessionStorage.setItem(SESSION_STORAGE_HIDE_CROSS_SELLING, 'true');
          setHideCrossSelling('true');
        }}
      />
      {isXs &&
        <StyledIconsDiv>
          <img src={imgsrc} alt={t('lobAlt')} />
        </StyledIconsDiv>}
      <div>
        <StyledT>
          <SafeHtml>{ads?.title}</SafeHtml>
        </StyledT>
        <StyledP>
          <SafeHtml>{`${ads?.text} `}</SafeHtml>
          <StyledLink data-testid="openCrossSelling" href={ads?.linkHref}>
            {ads?.linkText}
          </StyledLink>
        </StyledP>
      </div>
      {!isXs &&
        <StyledIconsDiv>
          <img src={imgsrc} alt={t('lobAlt')} />
        </StyledIconsDiv>}
    </StyledTile>

  );
};

export default CrossSellingContents;
